import React from 'react';
import './FinancialInfo.css';

const FinancialInfo = ({aspect}) => {
    return (
        <div className="container financial__info__container row align-items-center">
            <div className="col-md-7">
                <h3>{`What is ${aspect.title} ?`}</h3>
                <br/>
                <br/>
                <p>
                    {aspect.description}
                </p>
            </div>
            <div className="col-md-5">
                <img src={aspect.image} alt="aspect" className="w-75"/>
            </div>
        </div>
    )
}

export default FinancialInfo
